import { Menu } from '@/@types/index';
import { MenuResponse } from '../menu/models/MenuResponse';

export function mapMenu(menu: MenuResponse): Menu {
  return {
    name: menu.name,
    slug: menu.slug,
    industries: menu.industries?.map(industry => ({
      ...industry,
      order: industry.order,
      families: industry.families.map(family => ({
        title: family.title ?? '',
        slug: family.slug,
      })),
    })) ?? [],
    parts_services: menu.parts_services?.map(item => ({
      title: item.title ?? '',
      slug: item.slug,
    })) ?? [],
    tires_industries: menu.tires_industries?.map(industry => ({
      ...industry,
      tires: industry.tires.map(tire => ({
        title: tire.title ?? '',
        slug: tire.slug,
      })),
    })) ?? [],
    technological_solutions: menu.technological_solutions?.map(item => ({
      title: item.title ?? '',
      slug: item.slug,
    })) ?? [],
    promotions: menu.promotions?.map(item => ({
      title: item.title ?? '',
      slug: item.slug,
      link: item.link,
      is_blank: item.is_blank,
    })) ?? [],
    brands: menu.brands?.map(item => ({
      title: item.title ?? '',
      slug: item.slug,
    })) ?? [],
    inventories: menu.inventories?.map(item => ({
      title: item.title ?? '',
      slug: item.slug,
    })) ?? [],
    rents: menu.rents?.map(item => ({
      title: item.title ?? '',
      slug: item.slug,
      link: item.link,
    })) ?? [],
  };
}